<template>
  <b-sidebar v-model="visible" id="sidebar-right" header-class="bg-info" sidebar-class="border-left border-info" right shadow backdrop no-close-on-backdrop no-close-on-esc style="z-index:2000;">
    <template #header="{ hide }">
      <b-button-close @click="hide" class="text-white" />
      <small class="text-white">Users</small>
    </template>
    <template #footer="{ hide }">
      <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
      </div>
    </template>
    <b-button v-b-toggle.sidebar-right variant="info" class="position-absolute" style="top:50vh;transform: translateX(-100%);border-radius: 50% 0 0 50%;">
      <i class="far fa-comment-dots"></i>
    </b-button>
    <b-list-group>
      <template v-if="$store.state.users.onlineUsers.length > 0">
        <b-list-group-item>
          <span class="float-right">
            <b-button variant="danger" size="sm" class="ml-3" @click.stop="$root.$emit('unsubscribeToPresenceChannel')">
              <i class="fas fa-sign-out-alt"></i>
            </b-button>
          </span>
        </b-list-group-item>
        <b-list-group-item v-for="(user, uindex) in $store.state.users.onlineUsers" :key="`uo-${uindex}`">
          <strong>{{ user.name }}</strong>
          <span class="float-right">
            <b-button variant="primary" size="sm" class="ml-3" @click.stop="messageToUser(user)" :title="$t('users.sendmessage')">
              <i class="far fa-comment-dots"></i>
            </b-button>
          </span>
        </b-list-group-item>
      </template>
      <template v-else>
        <b-col cols="12" class="text-center mt-1">
          <b-button variant="primary" size="sm" @click.stop="$root.$emit('subscribeToPresenceChannel')">
            <i class="fas fa-sign-in-alt"></i>
          </b-button>
        </b-col>
      </template>
    </b-list-group>
  </b-sidebar>
</template>

<script>
export default {
  name: 'SidebarRight',
  mixins: [],
  props: {},
  components: {},
  data () {
    return {
      visible: false
    }
  },
  methods: {
    messageToUser(user) {
      this.visible = false
      this.$root.$emit('showUserMessage', user._id, user.name)
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
